import React from "react";
import * as yup from "yup";
import {
  MINIMUM_OCCURRENCE_VALUE,
  MINIMUM_RECURRENCE_VALUE,
  PRIMARY_DARK_GREEN,
} from "../../../../constants";
import getButtonTextColor from "../../../../helpers/getButtonTextColor";
import PrimaryButton from "../../Buttons/PrimaryButton";
import RadioButton from "../../Buttons/RadioButton";
import TertiaryButton from "../../Buttons/TertiaryButton";
import DatePicker from "../../DatePicker/DatePicker";
import Dropdown from "../../Dropdown/Dropdown";
import PopupHeader from "../PopupHeader";
import NumberInput from "./NumberInput";
import useCustomRecurrencePopupData from "./useCustomRecurrencePopupData";

const CustomRecurrencePopup = ({ closePopup, popupData }) => {
  const {
    activeRadioButton,
    daySelectOptions,
    frequencyOptions,
    repetition,
    date,
    saveButtonDisabled,
    occurrences,
    activeFrequencyOption,
    isDaySelectShown,
    isMonthSelectShown,
    activeMonthylSelectOption,
    monthlySelectOptions,
    handleSubmit,
    setNumberToStop,
    setEndDate,
    setFreqRepetition,
    setFreqOptionSelected,
    setActiveRadio,
    toggleDayActive,
    setMonthlyRepeatActiveOption,
  } = useCustomRecurrencePopupData({ popupData, closePopup });

  return (
    <>
      <PopupHeader closePopup={closePopup} />
      <div
        style={{ width: "400px" }}
        className="px-4 pb-4 rounded-b-lg border-l border-b border-r"
      >
        <h1 className="font-bold tracking-wider">Custom Repeat</h1>
        <div className="grid grid-cols-12 gap-2 mt-5 pb-8 items-center">
          <p className="col-span-4 text-md text-gray-400">Repeat every</p>
          <NumberInput
            className="col-span-2"
            onChange={setFreqRepetition}
            value={repetition}
            disabled={false}
            minValue={MINIMUM_RECURRENCE_VALUE}
          />

          <Dropdown
            tabIndex={0}
            name="recurrence"
            placeholder="None"
            className="col-span-5"
            options={frequencyOptions}
            value={activeFrequencyOption}
            onChange={(val) => setFreqOptionSelected(val.label)}
            disableSort
            isDisabled={false}
            disableClear
          />
        </div>

        {isDaySelectShown && (
          <>
            <p className="text-md text-gray-400 mb-2">Repeat on</p>

            <div className="flex justify-between pb-8">
              {daySelectOptions.map(({ dayEbr, active }) => {
                return (
                  <button
                    key={dayEbr}
                    type="button"
                    className="shadow-sm"
                    style={{
                      height: "40px",
                      width: "40px",
                      backgroundColor: active ? PRIMARY_DARK_GREEN : "#F9F9FA",
                      color: getButtonTextColor(repetition, active),
                      fontWeight: "bold",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      overflow: "hidden",
                      padding: "10px",
                    }}
                    onClick={() => toggleDayActive(dayEbr)}
                  >
                    <p className="text-sm">{dayEbr}</p>
                  </button>
                );
              })}
            </div>
          </>
        )}

        {isMonthSelectShown && (
          <div>
            <p className="text-md text-gray-400 mb-2">Repeat on</p>
            <Dropdown
              tabIndex={0}
              className="col-span-5 pb-8"
              options={monthlySelectOptions}
              value={activeMonthylSelectOption}
              onChange={(val) => setMonthlyRepeatActiveOption(val.value)}
              disableSort
              isDisabled={false}
              disableClear
            />
          </div>
        )}

        <div className="pb-8">
          <p className="text-md text-gray-400">Ends</p>
          <div className="pt-4 flex items-center">
            <RadioButton
              isChecked={activeRadioButton === "Never"}
              onChange={() => {
                setActiveRadio("Never");
              }}
            />
            <p
              className="text-md text-gray-400"
              style={{ width: "80px", marginLeft: "20px" }}
            >
              Never
            </p>
          </div>
          <div className="pt-4 flex items-center">
            <RadioButton
              isChecked={activeRadioButton === "On"}
              onChange={() => setActiveRadio("On")}
            />
            <p
              className="pr-4 text-md text-gray-400"
              style={{
                width: "80px",
                marginLeft: "20px",
              }}
            >
              On
            </p>
            <DatePicker
              onChange={(e) => setEndDate(e)}
              validation={yup.date()}
              value={date}
              disabled={activeRadioButton !== "On"}
              dateFormat="MMM do, yyyy"
            />
          </div>
          <div className="pt-4 flex items-center">
            <RadioButton
              type="radio"
              isChecked={activeRadioButton === "After"}
              onChange={() => setActiveRadio("After")}
            />
            <p
              className="text-md text-gray-400"
              style={{
                width: "80px",
                marginLeft: "20px",
              }}
            >
              After
            </p>
            <NumberInput
              disabled={activeRadioButton !== "After"}
              onChange={setNumberToStop}
              value={occurrences}
              text={`occurrence${occurrences > 1 ? "s" : ""}`}
              minValue={MINIMUM_OCCURRENCE_VALUE}
            />
          </div>
        </div>
        <div className="flex gap-4">
          <PrimaryButton
            border="primaryGreen"
            fontColor="white"
            saveButton
            onClick={() => handleSubmit()}
            disabled={saveButtonDisabled}
          />
          <TertiaryButton
            formCancelButton
            title="cancel"
            onClick={() => closePopup()}
          />
        </div>
      </div>
    </>
  );
};

export default CustomRecurrencePopup;
